import "./RecentSales.css";
import cancel from "../../../../../assets/cancel.png";
const RecentSalesModal = ({ setRecentSalesModal }) => {
 return (
  <div className="recent-sales-modal">
   <div className="overlay"></div>
   <div className="modal-box mobile">
    <div className="header">
     <p className="title">RUBWA1235</p>
     <p
      className="close-modal"
      onClick={() => {
       setRecentSalesModal(false);
      }}
     >
      <img src={cancel} alt="cancel" />
     </p>
    </div>
    <p className="date">06-08-2021</p>
    <div className="details-container">
     <div className="content">
      <div>
       <p>Amount</p>
       <p>N45,000</p>
      </div>

      <div>
       <p>Reference number</p>
       <p>RUBVWA1235</p>
      </div>
     </div>

     <div className="content">
      <div>
       <p>Transaction type</p>
       <p>Mind Games of a Broken Heart</p>
      </div>

      <div>
       <p>Status</p>
       <p className="button">Completed</p>
      </div>
     </div>

     <div className="content">
      <div>
       <p className="description">Commission charges</p>
       <p className="">N450</p>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default RecentSalesModal;
